import React, { useState } from 'react'
import { observer } from 'mobx-react-lite'
import { Stack } from '@mui/material'
import { NoteAdd } from '@mui/icons-material'

import { Button } from '@trivie/ui-web/components/button'
import { Text } from '@trivie/ui-web/components/text'
import { color } from '@trivie/ui-web/theme'
import { ResourceComponent } from '@trivie/ui-web/components/resource-component'
import { Panel } from '@trivie/ui-web/components/panel/panel'

import { ReactComponent as NullState } from '../null-states/null-resource-settings.svg'
import { ResourceUploadDialog } from './resource-upload-dialog'

export const QuizResourceSettings = observer((props: any) => {
  const { quiz } = props
  const [showResourceDialog, setShowResourceDialog] = useState(false)

  return (
    <Panel
      title="Sources"
      badge={quiz?.resources?.length}
      action={
        <Button
          size="small"
          color="info"
          onClick={() => setShowResourceDialog(true)}
          variant="outlined"
          startIcon={<NoteAdd />}
          text="Add Source"
        />
      }
      sx={{
        mb: 3,
        border: 'none !important',
        background: 'rgba(248, 250, 253)',
        flex: 1,
        paddingTop: '64px',
      }}
      divider
    >
      {!quiz?.resources?.length ? (
        <Stack flex={1} justifyContent="center" alignItems="center" sx={{ mb: '120px' }}>
          <NullState style={{ alignSelf: 'center' }} />
          <Text
            style={{ color: color.palette.grey }}
            text="Attach sources to help learners prepare for their quiz."
            variant="body2"
          />
        </Stack>
      ) : (
        <Stack gap={4} useFlexGap>
          {quiz?.resources?.length ? (
            <Stack useFlexGap gap={2}>
              <Stack useFlexGap gap={1}>
                <Text
                  style={{ color: color.palette.grey }}
                  text="These sources are only associated with this specific quiz."
                  variant="body2"
                />
              </Stack>
              {quiz.resources?.map((resource) => {
                return (
                  <ResourceComponent
                    key={`${resource.source_id}-q`}
                    inline
                    edit={resource.editing}
                    resource={resource}
                    isSelected={false}
                    onClick={(r) => {}}
                    hideEdit
                    onRemove={() => quiz?.removeResource(resource)}
                  />
                )
              })}
            </Stack>
          ) : null}
        </Stack>
      )}
      {showResourceDialog && (
        <ResourceUploadDialog
          quiz={quiz}
          close={() => setShowResourceDialog(false)}
          open={showResourceDialog}
        />
      )}
    </Panel>
  )
})
